import { render, staticRenderFns } from "./schoolResourcesCategoryDetail.vue?vue&type=template&id=1e3f158c"
import script from "./schoolResourcesCategoryDetail.vue?vue&type=script&lang=js"
export * from "./schoolResourcesCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports